import { DataTableColumnDef } from "@/components/molecules";
import { PreferredDriversTableData } from "./types";

export const preferredDriversColumns: DataTableColumnDef<PreferredDriversTableData>[] = [
  {
    accessorKey: "driverId",
    header: "Driver ID",
    id: "driverId",
    cell: (props) => props.row.original.driverId,
    size: 180,
    // Cells hold JSX, so TanStack's auto sort direction would be desc-first; sort asc on first click.
    sortDescFirst: false,
  },
  {
    accessorKey: "driverName",
    header: "Driver Name",
    id: "driverName",
    cell: (props) => props.row.original.driverName,
    size: 300,
    sortDescFirst: false,
  },
  {
    accessorKey: "action",
    header: "Action",
    id: "action",
    cell: (props) => props.row.original.action,
    size: 75,
    enableSorting: false,
  },
];
